const paginationLocale = {
  detail: "Showing {{pageStart}}-{{pageEnd}} of {{total}} items",
  first: "First",
  previous: "Previous",
  next: "Next",
  last: "Last",
  morePages: "More pages",
  page: "{{page}} / page"
};
export {
  paginationLocale
};
//# sourceMappingURL=en_US.js.map
